import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import Title from "../../Title/Title";
import { useDelete, useFetch, useFilter } from "../../../ApiS";
import { useParams } from "react-router-dom";
import Add from "../../Buttons/Add";
import { useState } from "react";
import { IoMdAdd } from "react-icons/io";
import PopUp from "../../PopUp";
import { Dialog } from "../../ui/Dialog";
import Search from "../../Search/Search";
import Table, { TableOperation } from "../../Table";
import { RiEditBoxFill } from "react-icons/ri";
import { FaEye, FaRegTrashAlt } from "react-icons/fa";
import { usePopUpsStore } from "../../../store/PopUpStore";
import Pagination from "../../pagination/Pagination (1)";
import PopUpDelete from "../../PopUps/PopUpDelete (1)";
import Loader from "../../Loader";

interface CurriculumsData {
  data: { data: Curriculums[]; last_page: number };
}

interface Curriculums {
  id: number;
  code: string;
  name_en: string;
  name_ar: string;
  min_pass_mark: number;
  theoretical_mark: number;
  practical_mark: number;
  assistances_marks: number;
  type: number;
  is_optional: boolean;
}

export default function Curriculums() {
  const operations: TableOperation[] = [
    {
      name: "show",
      icon: FaEye,
      link: true,
      onClick: () => {
        console.log("View");
      },
    },
    {
      name: "edit",
      icon: RiEditBoxFill,
      link: true,
      onClick: () => {
        console.log("edit");
      },
    },
    {
      name: "delete",
      icon: FaRegTrashAlt,
      link: true,
      onClick: (id) => {
        setPopUpDelete([id, true]);
      },
    },
  ];
  const [create, setCreate] = useState<boolean>(false);
  const { setPopUpDelete, popUpDelete } = usePopUpsStore();
  const { searchParams } = useFilter();

  const { id } = useParams();
  const page = searchParams.get("page") || 1;
  const search = searchParams.get("search") || "";

  const { data, isLoading } = useFetch(
    `admin/curriculums?page=${page}&search=${search}`,
    `admin/curriculums?page=${page}&search=${search}`
  );
  const { mutation, deleteItem } = useDelete(
    () => window.location.reload(),
    () => console.log(mutation.error)
  );

  return (
    <>
      <Row>
        <Col>
          <Title title="المقررات" />
        </Col>
      </Row>
      <Row justify="center">
        <Col lg={11} className="flex justify-center">
          <Search
            placeholder=" اسم الخصم"
            className="!w-[80%] border-2 border-[#efc5e6]"
          />
        </Col>
      </Row>
      {isLoading && <Loader/>}
      <Row justify="center">
        <Table<Curriculums>
          tableHeads={[
            "رقم المنهاج",
            "رمز المقرر",
            "اسم المقرر بالعربي",
            " اسم المقرر بالانكليزي",

            "العمليات",
          ]}
          tableBody={data?.data?.data}
          keys={["id", "code", "name_en", "name_ar"]}
          operations={operations}
          className="lg:min-w-[100px] md:min-w-[50px]"
        />
      </Row>
      {data?.data?.data?.length > 0 && (
        <Pagination pageCount={data?.data?.last_page} />
      )}

      <PopUpDelete
        text="هل أنت متأكد من حذف هذا المقرر؟"
        onClickDelete={() => {
          deleteItem(`admin/curriculums/${popUpDelete[0]}`);
          mutation.isLoading && <Loader />;
        }}
      />

      <Add link="/curriculums/add" />
    </>
  );
}
